import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Dimension__toString_impl_o4q1ad26wkwcghhu2zh as Dimension__toString_impl_o4q1ad,
  _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr,
} from '../../models/data.mjs';
import { Debugger_getInstancengm4b9abzu1y as Debugger_getInstance } from '../Element.mjs';
import {
  get_debugMode2ku08uo1anfv as get_debugMode,
  Default_getInstance27jodt8hd1bac as Default_getInstance,
} from '../../debugger.mjs';
import { get_px1lajc6xaddk2r as get_px } from '../../models/data.js.mjs';
import { indexOfa2zokh3tu4p6 as indexOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from '../NativeContainerElement.commonHtml.mjs';
import {
  get_spacingForChildCornerRadii2ikrz4gsg7d4b as get_spacingForChildCornerRadii,
  LinearLayoutElement3ltvobok1lxtu as LinearLayoutElement,
} from './LinearLayouts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _set_complex__k605rf($this, value) {
  $this.complex_1 = value;
  if (!value)
    $this.native_1.classes_1.add_utx5q5_k$('optimized');
  else
    $this.native_1.classes_1.remove_cedx0m_k$('optimized');
}
function enterFlexMode($this) {
  if (!$this.complex_1) {
    _set_complex__k605rf($this, true);
    // Inline function 'com.lightningkite.kiteui.views.display' call
    $this.native_1.style_1.native_1.display = 'flex';
    var _iterator__ex2g4s = $this.get_children_4cwbp4_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var child = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.marginBottom' call
      get_native(child).style_1.native_1.marginBottom = '0px';
    }
  }
}
var RowOrColClass;
function RowOrCol() {
  if (RowOrColClass === VOID) {
    class $ extends NativeLinearLayoutElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        // Inline function 'com.lightningkite.kiteui.views.flexDirection' call
        this.native_1.style_1.native_1.flexDirection = 'column';
        var tmp0 = this.native_1.classes_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = 'kiteui-flex';
        tmp0.add_utx5q5_k$(element);
        var tmp0_0 = this.native_1.classes_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = 'kiteui-col';
        tmp0_0.add_utx5q5_k$(element_0);
        this.native_1.classes_1.add_utx5q5_k$('optimized');
        this.complex_1 = false;
        this.vertical_1 = true;
      }
      set_vertical_nuap32_k$(value) {
        this.vertical_1 = value;
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.flexDirection' call
        var value_0 = value ? 'column' : 'row';
        tmp0.native_1.flexDirection = value_0;
        if (value) {
          var tmp0_0 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element = 'kiteui-row';
          tmp0_0.remove_cedx0m_k$(element);
          var tmp0_1 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'kiteui-col';
          tmp0_1.add_utx5q5_k$(element_0);
        } else {
          var tmp0_2 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element_1 = 'kiteui-col';
          tmp0_2.remove_cedx0m_k$(element_1);
          var tmp0_3 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_2 = 'kiteui-row';
          tmp0_3.add_utx5q5_k$(element_2);
        }
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        var native = element.get_underlyingNativeElement_vngz33_k$().native_1;
        var tmp;
        if (!this.vertical_1) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
          var tmp_0 = native.style_1.native_1.flexGrow;
          var tmp0_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
          var tmp_1;
          if (tmp1_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_1 = tmp1_safe_receiver > 0.0;
          }
          tmp = tmp_1 === true;
        }
        if (tmp) {
          enterFlexMode(this);
        }
        var align = this.vertical_1 ? native.desiredHorizontalGravity_1 : native.desiredVerticalGravity_1;
        switch (align == null ? -1 : align.ordinal_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            native.style_1.native_1.alignSelf = 'start';
            break;
          case 1:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            native.style_1.native_1.alignSelf = 'center';
            break;
          case 2:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            native.style_1.native_1.alignSelf = 'end';
            break;
          default:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            native.style_1.native_1.alignSelf = 'stretch';
            break;
        }
        if (!this.complex_1) {
          switch (align == null ? -1 : align.ordinal_1) {
            case 0:
              // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

              native.style_1.native_1.marginLeft = 'unset';
              // Inline function 'com.lightningkite.kiteui.views.marginRight' call

              native.style_1.native_1.marginRight = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_2 = native.style_1.native_1.width;
              // Inline function 'kotlin.let' call

              var it = (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : null;
              if (it == null || it === '') {
                var tmp0 = native.style_1;
                // Inline function 'com.lightningkite.kiteui.views.width' call
                var value = 'fit-content';
                tmp0.native_1.width = value;
              }

              break;
            case 1:
              // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

              native.style_1.native_1.marginLeft = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.marginRight' call

              native.style_1.native_1.marginRight = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_3 = native.style_1.native_1.width;
              // Inline function 'kotlin.let' call

              var it_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'string' : false) ? tmp_3 : null;
              if (it_0 == null || it_0 === '') {
                var tmp0_0 = native.style_1;
                // Inline function 'com.lightningkite.kiteui.views.width' call
                var value_0 = 'fit-content';
                tmp0_0.native_1.width = value_0;
              }

              break;
            case 2:
              // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

              native.style_1.native_1.marginLeft = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.marginRight' call

              native.style_1.native_1.marginRight = 'unset';
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_4 = native.style_1.native_1.width;
              // Inline function 'kotlin.let' call

              var it_1 = (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : null;
              if (it_1 == null || it_1 === '') {
                var tmp0_1 = native.style_1;
                // Inline function 'com.lightningkite.kiteui.views.width' call
                var value_1 = 'fit-content';
                tmp0_1.native_1.width = value_1;
              }

              break;
            default:
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_5 = native.style_1.native_1.width;
              // Inline function 'kotlin.text.isNullOrEmpty' call

              var this_0 = (!(tmp_5 == null) ? typeof tmp_5 === 'string' : false) ? tmp_5 : null;
              if (this_0 == null || charSequenceLength(this_0) === 0) {
                // Inline function 'com.lightningkite.kiteui.views.width' call
                native.style_1.native_1.width = '100%';
              }

              break;
          }
        }
        this.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
      }
      nativeClearChildren_cy0j45_k$() {
        super.nativeClearChildren_cy0j45_k$();
        this.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
      }
      nativeRemoveChild_8vu7sp_k$(index) {
        super.nativeRemoveChild_8vu7sp_k$(index);
        this.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
      }
      onStartup_vrxh3i_k$() {
        super.onStartup_vrxh3i_k$();
        this.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
      }
      rerunOptimizedBottomMarginCalc_6q5hy8_k$() {
        if (this.complex_1)
          return Unit_instance;
        var tmp0 = this.get_children_4cwbp4_k$();
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.lastOrNull' call
          var iterator = tmp0.listIterator_70e65o_k$(tmp0.get_size_woubt6_k$());
          while (iterator.hasPrevious_qh0629_k$()) {
            var element = iterator.previous_l2dfd5_k$();
            // Inline function 'com.lightningkite.kiteui.views.hidden' call
            var tmp = get_native(element).attributes_1.native_1.hidden;
            if (!(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true)) {
              tmp$ret$0 = element;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }
        var newLastShownElement = tmp$ret$0;
        var tmp0_elvis_lhs = this.get_gap_83dt6d_k$();
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = get_theme(this).gap_1;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var amnt = tmp_0;
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp_2;
        if (!true && get_debugMode()) {
          tmp_2 = true;
        } else {
          var tmp0_safe_receiver = Debugger_getInstance().debugTarget_1;
          tmp_2 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp_2) {
          var tmp_3 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp_4 = Dimension__toString_impl_o4q1ad(amnt);
          var tmp0_safe_receiver_0 = this.get_gap_83dt6d_k$();
          var tmp_5;
          var tmp_6 = tmp0_safe_receiver_0;
          if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
            tmp_5 = null;
          } else {
            tmp_5 = get_px(tmp0_safe_receiver_0);
          }
          var tmp$ret$4 = 'gap: ' + tmp_4 + ' = (' + tmp_5 + ' px ?: ' + get_px(get_theme(this).gap_1) + ' px) t=' + get_theme(this).id_1;
          tmp_3.info_59mt0k_k$([tmp$ret$4]);
        }
        var _iterator__ex2g4s = this.get_children_4cwbp4_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var child = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_0 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.marginBottom' call
          var value = _Dimension___get_value__impl__urhqzr(amnt).toString();
          tmp0_0.native_1.marginBottom = value;
        }
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp_7;
        if (!true && get_debugMode()) {
          tmp_7 = true;
        } else {
          var tmp0_safe_receiver_1 = Debugger_getInstance().debugTarget_1;
          tmp_7 = (tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp_7) {
          var tmp_8 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$7 = 'last shown index: ' + indexOf(this.get_children_4cwbp4_k$(), newLastShownElement);
          tmp_8.info_59mt0k_k$([tmp$ret$7]);
        }
        var tmp2_safe_receiver = newLastShownElement == null ? null : get_native(newLastShownElement);
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          // Inline function 'com.lightningkite.kiteui.views.marginBottom' call
          tmp3_safe_receiver.native_1.marginBottom = '0';
        }
      }
      nativeApplyTheme_6heplg_k$(theme) {
        super.nativeApplyTheme_6heplg_k$(theme);
        this.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
      }
    }
    initMetadataForClass($, 'RowOrCol');
    RowOrColClass = $;
  }
  return RowOrColClass;
}
var NativeLinearLayoutElementClass;
function NativeLinearLayoutElement() {
  if (NativeLinearLayoutElementClass === VOID) {
    class $ extends NativeContainerElement() {
      constructor(context) {
        super(context);
        this.gap_1 = null;
      }
      set_gap_jwjroq_k$(value) {
        this.gap_1 = value;
        var tmp = this.native_1;
        var tmp_0;
        var tmp_1 = value;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _Dimension___get_value__impl__urhqzr(value);
        }
        var tmp1_safe_receiver = tmp_0;
        tmp.setStyleProperty_wavvb3_k$('--spacing', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString());
      }
      get_gap_83dt6d_k$() {
        return this.gap_1;
      }
      get_spacingForChildCornerRadii_uorqcm_k$() {
        return get_spacingForChildCornerRadii.call(this);
      }
    }
    initMetadataForClass($, 'NativeLinearLayoutElement', VOID, VOID, [LinearLayoutElement()]);
    NativeLinearLayoutElementClass = $;
  }
  return NativeLinearLayoutElementClass;
}
var RowWrappingClass;
function RowWrapping() {
  if (RowWrappingClass === VOID) {
    class $ extends NativeLinearLayoutElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.setStyleProperty_wavvb3_k$('display', 'flex');
        this.native_1.setStyleProperty_wavvb3_k$('flex-direction', 'row');
        this.native_1.setStyleProperty_wavvb3_k$('flex-wrap', 'wrap');
        var tmp0 = this.native_1.classes_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = 'kiteui-flex';
        tmp0.add_utx5q5_k$(element);
        var tmp0_0 = this.native_1.classes_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = 'kiteui-row-wrap';
        tmp0_0.add_utx5q5_k$(element_0);
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        var horizontalAlign = get_native(element).desiredHorizontalGravity_1;
        var verticalAlign = get_native(element).desiredVerticalGravity_1;
        switch (horizontalAlign == null ? -1 : horizontalAlign.ordinal_1) {
          case 0:
            get_native(element).setStyleProperty_wavvb3_k$('justify-self', 'start');
            break;
          case 1:
            get_native(element).setStyleProperty_wavvb3_k$('justify-self', 'center');
            break;
          case 2:
            get_native(element).setStyleProperty_wavvb3_k$('justify-self', 'end');
            break;
          default:
            get_native(element).setStyleProperty_wavvb3_k$('justify-self', 'stretch');
            break;
        }
        switch (verticalAlign == null ? -1 : verticalAlign.ordinal_1) {
          case 0:
            get_native(element).setStyleProperty_wavvb3_k$('align-self', 'start');
            break;
          case 1:
            get_native(element).setStyleProperty_wavvb3_k$('align-self', 'center');
            break;
          case 2:
            get_native(element).setStyleProperty_wavvb3_k$('align-self', 'end');
            break;
          default:
            get_native(element).setStyleProperty_wavvb3_k$('align-self', 'stretch');
            break;
        }
      }
    }
    initMetadataForClass($, 'RowWrapping');
    RowWrappingClass = $;
  }
  return RowWrappingClass;
}
var RowCollapsingToColumnClass;
function RowCollapsingToColumn() {
  if (RowCollapsingToColumnClass === VOID) {
    class $ extends NativeLinearLayoutElement() {
      constructor(context, breakpoints) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.classes_1.add_utx5q5_k$(context.kiteUiCss_1.rowCollapsingToColumn_6s7flu_k$(breakpoints));
        this.native_1.classes_1.add_utx5q5_k$('rowCollapsing');
      }
    }
    initMetadataForClass($, 'RowCollapsingToColumn');
    RowCollapsingToColumnClass = $;
  }
  return RowCollapsingToColumnClass;
}
//region block: exports
export {
  NativeLinearLayoutElement as NativeLinearLayoutElement1dab1ox1m83nf,
  RowCollapsingToColumn as RowCollapsingToColumn13iucsgmjquhb,
  RowOrCol as RowOrCol3a33s3yce2tuv,
  RowWrapping as RowWrapping1cfo2cqk4jxme,
};
//endregion

//# sourceMappingURL=LinearLayouts.commonHtml.mjs.map
